<template>
    <div class="container box-like">
        <div class="button-box">
            <a-button icon="interaction" type="primary" @click="onDistribution">分配卡</a-button>
            <a-button icon="retweet" @click="onFilterAllReset">重置所有筛选条件</a-button>
        </div>
        <!-- scroll: 页面太小的时候会让表格至少有相应的长度，如果表格项很少就去掉这个，表格项太多的话适当增加 -->
        <a-table :data-source="tableData" :columns="columns" :rowKey="(rec) => rec.id" :scroll="{ x: 600 , y: 66 * 10}"
            :pagination="pageConfig" :transformCellText="({text}) => text ? text : '-'">
            <!-- slot对应配置文件中customRender的内容 -->
            <a-space size="small" slot="c-type" slot-scope="text, record">
                <a-tag color="green" v-if="text === 1">{{cardUsingType[text]}}</a-tag>
                <a-tag v-if="text === 2">{{cardUsingType[text]}}</a-tag>
                <a-tag color="orange" v-if="text === 3">{{cardUsingType[text]}}</a-tag>
                <a-tag color="orange" v-if="text === 4">{{cardUsingType[text]}}</a-tag>
                <a-tag color="red" v-else-if="text === 5">{{cardUsingType[text]}}</a-tag>
                
                <a @click="toRefuseReturn(record)" v-if="record.user_type === 3">拒绝退回</a>
                <a @click="toReturnCard(record)" v-if="text === 4">确认退回</a>
            </a-space>
            <div slot="c-money" slot-scope="text, record">
                <a-space size="small" v-if="text">
                    <div>{{text}}</div>
                    <a-popover title="余额充值" trigger="click" @visibleChange="(e) => { if (e) chargeMoney = '' }">
                        <a-space direction="vertical" size="small" slot="content">
                            <a-input-number :min="0" :max="1000000" placeholder="请输入充值金额" style="width: 160px" v-model="chargeMoney"></a-input-number>
                            <a-button type="primary" @click="toCharge(record)">确认</a-button>
                        </a-space>
                        <a v-if="record.admin_type === 1">充值</a>
                    </a-popover>
                </a-space>
                <div v-else>-</div>
            </div>
            <div slot="c-action" slot-scope="text, record" style="display: flex;">
                <a-button type="primary" style="margin-right: 4px;" @click="onEdit(record)">编辑</a-button>
                <!-- <a-button type="danger" @click="onDelete(record.id)">删除</a-button> -->
            </div>
            <div slot="filterDropdown" slot-scope="{ confirm, column }" style="padding: 8px">
                <a-input class="filter-input" :placeholder="`搜索${column.title}`" v-model="filterItems[column.filterIndex]"
                    v-if="column.type === 'input'" />
                <a-select class="filter-select" :placeholder="`请选择${column.title}`" :mode="column.multi ? 'multiple' : ''"
                    v-model="filterItems[column.filterIndex]" v-if="column.type === 'select'">
                    <a-select-option :value="item.id" v-for="(item, index) in column.items" :key="index">{{item.name}}</a-select-option>
                </a-select>
                <div>
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px" @click="onFilterSearch(confirm)">搜索</a-button>
                    <a-button size="small" icon="retweet" style="width: 90px" @click="onFilterReset(column.filterIndex, confirm)">重置</a-button>
                </div>
            </div>
            <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
        </a-table>

        <div class="statistic">
            <a-statistic title="余额总计" :value="totalMoney" style="margin-right: 50px">
                <template slot="suffix">
                    <div>元</div>
                </template>
            </a-statistic>
        </div>

        <a-modal title="编辑信息" :visible="showModal" okText="提交" cancelText="返回" @ok="submit" :maskClosable="false"
            centered @cancel="showModal = false">
            <a-form-model ref="modelForm" layout="horizontal" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }" :model="formModel">
                <a-form-model-item :label="item.title" :prop="`${index}.value`" :rules="item.rules" v-for="(item, index) in formModel"
                    :key="index" v-show="!item.hide">
                    <a-input :type="item.aliasType" v-model="item.value" :placeholder="item.placeholder || `请输入${item.title}`" v-if="item.type === 'input'" />
                    <a-input-number v-model="item.value" :min="item.min" :max="item.max" :step="item.step || 1" :placeholder="item.placeholder || `请输入${item.title}`" style="width: 100%" v-if="item.type === 'inputNumber'" />
                    <a-select :placeholder="item.placeholder || `请选择${item.title}`" :mode="item.multi ? 'multiple' : ''" v-model="item.value"
                        v-if="item.type === 'select'">
                        <a-select-option :value="item2.id" v-for="(item2, index2) in item.items" :key="index2">{{item2.name}}</a-select-option>
                    </a-select>
                    <a-date-picker v-model="item.value" placeholder="请选择日期" value-format="YYYY-MM-DD" style="width: 100%" v-if="item.type === 'date'" />
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
import {
    mapState,
    mapMutations
} from 'vuex'
import { cardUsingType } from '@/common/project-config'
import {
    formModel,
    columns
} from './seller.conf'

export default {
    name: 'card_seller',
    computed: {
        ...mapState('stored', ['userInfo'])
    },
    data() {
        return {
            // 当前选中的id，只有编辑的时候需要，新增时改为-1
            selectedId: -1,
            // 表格数据
            tableData: [],
            // 显示编辑内容
            showModal: false,
            // 筛选内容
            filterItems: {},
            // 编辑内容配置，在配置文件里
            formModel: { ...formModel},
            // 表格配置，在配置文件里
            columns: [...columns],
            // 分页配置
            pageConfig: {
                current: 1,
                pageSize: 10,
                total: 0,
                pageSizeOptions: ['10', '20', '50', '100', '500'],
                showSizeChanger: true,
                onChange: (a, b) => {
                    this.pageConfig.current = a
                    this.pageConfig.pageSize = b
                    this.onInit()
                },
                onShowSizeChange: (a, b) => {
                    this.pageConfig.current = 1
                    this.pageConfig.pageSize = b
                    this.onInit()
                }
            },
            // 卡使用状态
            cardUsingType,
            // 充值金额
            chargeMoney: '',
            // 余额总计
            totalMoney: 0
        }
    },
    created() {

    },
    mounted() {
        this.onInit(true)
    },
    props: {

    },
    watch: {

    },
    methods: {
        ...mapMutations('global', ['setLoading']),
        async onInit(reMap) {
            // 开始loading
            this.setLoading('页面加载中...')
            if (reMap) {
                await this.initMap()
            }
            // 请求地址，在controller里面编辑
            let res = await this.$util.request(this.$ctrl.card.getSellCard, {
                status: this.userInfo.stationId,
                page: this.pageConfig.current,
                limit: this.pageConfig.pageSize,
                ...this.filterItems
            })
            // 如果需要对后端返回的值进行转换在这里转
            this.tableData = res.data.data
            // 其它的逻辑写在这里
            this.totalMoney = res.sum
            this.pageConfig.total = res.data.total
            // 结束loading
            this.setLoading('')
        },
        async initMap() {
            // 一般情况下，这里写的是选择型的筛选条件的选项，从后端获取
            let res, index
            // 卡号前缀
            res = await this.$util.request(this.$ctrl.card.getCardPrefix, {
                status: this.userInfo.stationId,
                page: 1,
                limit: 9999
            })
            this.formModel.title.items = res.data

            // 经销商名称
            res = await this.$util.request(this.$ctrl.card.getCardSeller, {
                status: this.userInfo.stationId,
                page: 1,
                limit: 9999
            })
            this.formModel.admin_id.items = res.data.data
        },
        onFilterSearch(confirm) {
            this.pageConfig.current = 1
            this.onInit()
            confirm()
        },
        onFilterReset(key, confirm) {
            if (this.filterItems.hasOwnProperty(key)) {
                this.filterItems[key] = ''
                this.filterItems[key] = undefined
                this.pageConfig.current = 1
                this.onInit()
                confirm()
            }
        },
        onFilterAllReset() {
            Object.keys(this.filterItems).forEach((k) => {
                this.filterItems[k] = undefined
            })
            this.pageConfig.current = 1
            this.onInit()
        },
        onDistribution() {
            this.selectedId = -1
            this.showModal = true
            this.$nextTick(() => {
                this.$refs.modelForm.resetFields()
            })
        },
        onEdit(e) {
            this.selectedId = e.id
            this.formModel.card.hide = true
            this.formModel.type.hide = false
            this.formModel.money.hide = false
            this.showModal = true
            this.$nextTick(() => {
                this.$refs.modelForm.resetFields()
                Object.entries(e).forEach(([k, v]) => {
                    if (this.formModel.hasOwnProperty(k)) {
                        this.formModel[k].value = v
                    }
                })
            })
        },
        onDelete(e) {
            this.$confirm({
                title: '提示',
                content: '确定要删除吗？',
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                centered: true,
                onOk: () => {
                    this.$util.request(this.$ctrl.admin_manager.del, {
                        id: e
                    }).then((res) => {
                        if (res.code === 1) {
                            this.$success({
                                title: '提示',
                                content: '删除成功',
                                centered: true
                            })
                            if (this.tableData.length <= 1 && this.pageConfig.current > 1) {
                                this.pageConfig.current -= 1
                            }
                            this.onInit()
                        } else {
                            this.$error({
                                title: '提示',
                                content: '删除失败',
                                centered: true
                            })
                        }
                    })
                }
            })
        },
        submit() {
            this.$refs.modelForm.validate((valid) => {
                if (valid) {
                    let modelValues = Object.entries(this.formModel).reduce((p, [k, v]) => {
                        p[k] = v.value
                        return p
                    }, {})
                    this.$util.request(this.$ctrl.card.activeSellerCard, {
                        status: this.userInfo.stationId,
                        ...modelValues
                    }).then((res) => {
                        if (res.code === 1) {
                            this.$success({
                                title: '提示',
                                content: '分配成功',
                                centered: true
                            })
                            this.showModal = false
                            this.onInit()
                        } else {
                            this.$error({
                                title: '提示',
                                content: '分配失败',
                                centered: true
                            })
                        }
                    })
                } else {
                    return false
                }
            })
        },
        toRefuseReturn({ cid, card }) {
            this.$confirm({
                title: '提示',
                content: `卡号${card}，拒绝退回？`,
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                centered: true,
                onOk: () => {
                    this.$util.request(this.$ctrl.card.refuseReturn, {
                        cid
                    }).then((res) => {
                        if (res.code === 1) {
                            this.$success({
                                title: '提示',
                                content: '拒绝退回成功',
                                centered: true
                            })
                            this.onInit()
                        } else {
                            this.$error({
                                title: '提示',
                                content: '拒绝退回失败',
                                centered: true
                            })
                        }
                    })
                }
            })
        },
        toReturnCard({ cid, card }) {
            this.$confirm({
                title: '提示',
                content: `卡号${card}，确认退回？`,
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                centered: true,
                onOk: () => {
                    this.$util.request(this.$ctrl.card.editSellCard, {
                        id: cid,
                        admin_type: 5
                    }).then((res) => {
                        if (res.code === 1) {
                            this.$success({
                                title: '提示',
                                content: '退回成功',
                                centered: true
                            })
                            this.onInit()
                        } else {
                            this.$error({
                                title: '提示',
                                content: '退回失败',
                                centered: true
                            })
                        }
                    })
                }
            })
        },
        toCharge({ cid, card }) {
            this.$confirm({
                title: '提示',
                content: `卡号${card}，充值金额为${this.chargeMoney}元，确认充值？`,
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                centered: true,
                onOk: () => {
                    this.$util.request(this.$ctrl.card.editSellCard, {
                        id: cid,
                        money: this.chargeMoney
                    }).then((res) => {
                        if (res.code === 1) {
                            this.$success({
                                title: '提示',
                                content: '充值成功',
                                centered: true
                            })
                            this.onInit()
                        } else {
                            this.$error({
                                title: '提示',
                                content: '充值失败',
                                centered: true
                            })
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
    @import './seller.less';
</style>
